const commonAndMisc = {
  errorMessage404: "Ops! La pagina che stai cercando non esiste", // translated
  backToHome: "Tornare a casa", // translated
  information: "Informazione", // translated
  additionalInformation: "Informazioni aggiuntive", // translated
  destinationPlaceholder: "Dove stai andando", // translated
  aboutUs: "Chi siamo", // translated
  pleaseWait: "Attendere prego...", // translated
  featuredHotels: "Hotel in primo piano", // translated
  topPackages: "I migliori pacchetti", // translated
  topTours: "I migliori tour", // translated
  traveller: "Viaggiatore", // translated
  reviews: "Recensioni", // translated
  home: "Casa", // translated
  packages: "Pacchetti", // translated
  experiences: "Esperienze", // translated
  close: "Chiudere", // translated
  loadingMessage: "Si prega di attendere mentre cerchiamo i migliori prezzi disponibili", // translated
  loadingMessageTheHotelCo: "Si prega di attendere mentre cerchiamo i migliori prezzi disponibili", // translated
  loadingMessageSearchStrip: "Si prega di attendere mentre stiamo cercando i migliori prezzi disponibili...", // translated
  topCountriesToVisit: "I migliori paesi da visitare", // translated
  profile: "Profilo", // translated
  reservations: "Prenotazioni", // translated
  address: "Indirizzo", // translated
  firstName: "Nome di battesimo", // translated
  lastName: "Cognome", // translated
  email: "E-mail", // translated
  login: "Login", // translated
  logout: "Disconnettersi", // translated
  myProfile: "Il mio profilo", // translated
  myChatRooms: "My Chats",
  chatRoomsListEmpty: "You have no chat rooms for this account.",
  chatRoomsOpen: "Open",
  chatRoomsLastActivity: "Last activity",
  chatRoomsUnread: "Unread",
  chatRoomsBadgeQuotation: "Quotation",
  chatRoomsBadgeTripOffer: "Trip offer",
  chatRoomsOpenQuotationAria: "Open quotation chat: {{name}}",
  chatRoomsOpenTripOfferAria: "Open trip offer chat: {{name}}",
  chatRoomsOpenGenericAria: "Open chat: {{name}}",
  quotationChatInvalidLink:
    "Invalid chat link. Open a chat from your profile or quotation list, or use exactly one of room_code or room_uid.",
  quotationChatNoTripDetails: "Trip details are not available for this chat.",
  chat: "Chat",
  verified: "Verificato", // translated
  unverified: "Non verificato", // translated
  selectLanguage: "Seleziona la lingua", // translated
  selectCurrency: "Seleziona valuta", // translated
  upgrade: "Aggiornamento", // translated
  membership: "Adesione", // translated
  travelTrust: "Fiducia di viaggio", // translated
  signInUp: "Accedi/Accedi", // translated
  worldwideHotelsAndResortsAtAmazingWholesaleRates: "hotel e resort in tutto il mondo a incredibili tariffe all'ingrosso", // translated
  dashboard: "Pannello", // translated
  pricing: "Prezzo", // translated
  refundable: "Rimborsabile", // translated
  cars: "Macchine", // translated
  cruises: "Crociere", // translated
  view: "Visualizzazione", // translated
  price: "Prezzo", // translated
  totalPrice: "Prezzo totale", // translated
  filterRoomName: "Filtra il nome della stanza", // translated
  get: "Ottenere", // translated
  guestInformationValidation: "Convalida delle informazioni sugli ospiti", // translated
  reservation: "Prenotazione", // translated
  checkIn: "Registrare", // translated
  checkOut: "Guardare", // translated
  paymentInitiattionErroeMessage: "Non è stato possibile avviare la procedura di pagamento. Ci scusiamo per l'inconveniente", // translated
  warning: "Avvertimento", // translated
  couldNotFindPriceForDateWarning: "Non siamo riusciti a trovare un prezzo per questa data. Riprova per una data diversa", // translated
  searchFormValidationError: "Errore di convalida del modulo di ricerca", // translated
  pleaseSelectValidDateFirst: "Seleziona prima una data valida", // translated
  searchError: "Errore di ricerca", // translated
  priceSearchInitiationError: "Non è stato possibile avviare il processo di ricerca del prezzo. Per favore riprova più tardi. Ci scusiamo per l'inconveniente", // translated
  searchWarning: "Avviso di ricerca", // translated
  couldNotFindPriceAndOrAvailability: "Non siamo riusciti a trovare il prezzo e/o la disponibilità per la tua richiesta. Ci scusiamo per l'inconveniente", // translated
  joinNow: "Iscriviti adesso", // translated
  signIn: "Registrazione", // translated
  searchNow: "Cerca ora", // translated
  bookingFailed: "Prenotazione fallita", // translated
  sorryForTheInconvenience: "Ci scusiamo per l'inconveniente", // translated
  paymentFailedTryAgain: "Pagamento fallito. Per favore riprova", // translated
  quickLinks: "Link veloci", // translated
  tours: "Tour", // translated
  termsAndConditions: "Termini e Condizioni", // translated
  pleaseWaitWhileInitiatingPayment: "Si prega di attendere mentre stiamo avviando il processo di pagamento", // translated
  back: "Di ritorno", // translated
  nextStep: "Passo successivo", // translated
  book: "Prenotare", // translated
  checkout: "Guardare", // translated
  specifyPickUpPoint: "Specifica il punto del tuo ritiro preferito", // translated
  pickupPoint: "Punto di raccolta", // translated
  optional: "opzionale", // translated
  remarks: "Osservazioni", // translated
  travellerInformation: "Informazioni sui viaggiatori", // translated
  bookingRemarks: "Osservazioni sulla prenotazione", // translated
  bookingOverview: "Panoramica della prenotazione", // translated
  paymentFailed: "Pagamento fallito", // translated
  paymentSuccess: "Pagamento riuscito", // translated
  at: "In", // translated
  person: "persona", // translated
  cancellationPolicy: "Politica di cancellazione", // translated
  From: "A partire dal", // translated
  to: "UN", // translated
  cancellationIs: "la cancellazione è", // translated
  pickup: "Raccogliere", // translated
  flights: "voli", // translated
  Accommodation: "Struttura ricettiva", // translated
  payAndBook: "Paga e prenota", // translated
  onRequest: "Su richiesta", // translated
  weAreFindingTheBestAvailableServices: "Stiamo trovando i migliori servizi disponibili", // translated
  withTheBestAvailablePrices: "con i migliori prezzi disponibili", // translated
  inRealTime: "in tempo reale", // translated
  seconds: "secondi", // translated
  thisProcessCanTakeUpToOneMinute: "Questo processo può richiedere fino a 1 minuto", // translated
  pleaseDoNotRefreshThisPage: "Si prega di non aggiornare questa pagina", // translated
  wellItSeemsItCanTakeBitLonger: "Beh... sembra che possa volerci un po' di più", // translated
  yourBrowserDoesNotSupportTheVideoTag: "Il tuo browser non supporta il tag video", // translated
  bookingSuccess: "Prenotazione riuscita", // translated
  bookingReference: "Riferimento prenotazione", // translated
  referenceCopied: "Riferimento copiato", // translated
  shortlyYouReceiveEmailContainingInformationForYourReservation: "A breve riceverai un'e-mail contenente tutte le informazioni richieste per la tua prenotazione", // translated
  viewMore: "Visualizza di più", // translated
  readMore: "Leggi di più", // translated
  customerSupport: "Servizio Clienti", // translated
  socialMedia: "Social media", // translated
  nearby: "Nelle vicinanze", // translated
  score: "Punto", // translated
  phoneNumberInTheFormat: "Il numero di telefono deve essere nel formato senza spazi", // translated
  noReservationsForThisProduct: "Nessuna prenotazione per questo prodotto", // translated
  phoneNumberIsRequired: "Il numero di telefono è obbligatorio", // translated
  notAvailable: "Non disponibile", // translated
  emailNotSentTryAgain: "E-mail non inviata! Per favore riprova", // translated
  security: "Sicurezza", // translated
  active: "Attivo", // translated
  clearYourFilters: "Deseleziona le opzioni di filtro per visualizzare i risultati", // translated
  found: "Trovato", // translated
  addressIsRequired: "L'indirizzo è obbligatorio", // translated
  applicationAvailable: "applicazione disponibile", // translated
  sendUsRequest: "Inviaci la tua richiesta", // translated
  emailHasBeenSent: "E-mail inviata con successo", // translated
  proceed: "Procedere", // translated
  lastNameIsRequired: "Il cognome è obbligatorio", // translated
  cityIsRequired: "La città è obbligatoria", // translated
  restaurants: "Ristoranti", // translated
  sendUsYourRequest: "Inviaci la tua richiesta", // translated
  postalCodeIsRequired: "Il codice postale è obbligatorio", // translated
  sendVoucherEmail: "Invia e-mail con il voucher", // translated
  status: "Stato", // translated
  hour: "ora", // translated
  clearAllFilters: "Cancella tutti i filtri", // translated
  clickHere: "clicca qui", // translated
  firstNameMustContainAlphabetic: "Il nome deve contenere solo caratteri alfabetici", // translated
  currency: "Valuta", // translated
  privacyPolicy: "politica sulla riservatezza", // translated
  progressAt: "Progresso a", // translated
  emailIsRequired: "L'e-mail è obbligatoria", // translated
  yourReservationIsInProgress: "La tua prenotazione è in corso", // translated
  confirmed: "Confermato", // translated
  star: "Stella", // translated
  sendCancellationEmail: "Invia e-mail di cancellazione", // translated
  minutes: "minuti", // translated
  invalidEmail: "E-mail non valido", // translated
  pending: "In attesa di", // translated
  noOptionsForSelectedFilters: "Nessuna opzione disponibile per la corrispondenza dei filtri", // translated
  minute: "minuto", // translated
  stars: "Stelle", // translated
  cancelled: "Annullato", // translated
  titleIsRequired: "Il titolo è obbligatorio", // translated
  errorContentUnavailable: "Ops! Il contenuto che stai cercando non esiste. Vi preghiamo di contattarci in merito al problema", // translated
  firstNameIsRequired: "Il nome è obbligatorio", // translated
  sendUsEmail: "Mandaci un email", // translated
  hours: "ore", // translated
  leadGuest: "Ospite principale", // translated
  reference: "Riferimento", // translated
  countryIsRequired: "Il Paese è obbligatorio", // translated
  distanceFromSelection: "Distanza dalla selezione", // translated
  memberId: "ID membro", // translated
  pleaseCheckTheBox: "Seleziona la casella per indicare di aver letto e accettato le informazioni fornite prima di procedere al passaggio successivo.", // translated
  lastNameMustContainAlphabetic: "Il cognome deve contenere solo caratteri alfabetici", // translated
  genderIsRequired: "Il sesso è obbligatorio", // translated
  visitSite: "Visita il sito", // translated
  downloadVoucher: "Scarica il buono", // translated
  iHaveReadAgreeWithAbove: "Ho letto e sono d'accordo con quanto sopra", // translated
  km: "km", // translated
  maintenanceTitle: "Sito web in manutenzione",
  maintenanceDescription:
    "Stiamo effettuando una manutenzione programmata. Torna a trovarci presto.",
  maintenanceCountdownLabel: "Tempo rimanente stimato",
  maintenanceLogoAlt: "Logo del sito web",
  maintenanceDays: "Giorni",
  maintenanceHours: "Ore",
  maintenanceMinutes: "Minuti",
  maintenanceSeconds: "Secondi",
  maintenanceStatusBadge: "Manutenzione programmata",
  maintenanceRefresh: "Aggiorna la pagina",
  maintenanceExpired:
    "La manutenzione dovrebbe essere completata a breve. Aggiorna la pagina.",
};

export default commonAndMisc;
